import React from 'react';
import { CheckCircleIcon, TruckIcon, ShieldCheckIcon, TimerIcon, AlertTriangleIcon, LockIcon, ArrowRightIcon } from 'lucide-react';
export function SpecialOffer() {
  return <section id="specialerbjudande" className="my-16 p-6 bg-amber-100 rounded-lg shadow-md special-offer" data-id="element-331">
      <div className="text-center mb-6" data-id="element-332">
        <div className="inline-block bg-red-600 text-white px-3 py-1 rounded-full text-sm font-bold mb-3 animate-pulse" data-id="element-333">
          Begränsat erbjudande - Endast tillgängligt i 48 timmar
        </div>
        <h2 className="text-2xl md:text-3xl font-bold text-amber-800 mb-2" data-id="element-334">
          Exklusivt erbjudande: Prova Brainy idag!
        </h2>
        <p className="text-lg text-amber-700" data-id="element-335">
          Begränsat till de första 250 beställningarna
        </p>
      </div>
      <div className="flex flex-col md:flex-row gap-8 mb-8" data-id="element-336">
        <div className="md:w-1/2" data-id="element-337">
          <div className="bg-white p-5 rounded-lg shadow-md mb-4 relative overflow-hidden" data-id="element-338">
            <div className="absolute top-0 right-0 bg-green-500 text-white text-xs px-2 py-1" data-id="element-339">
              MEST POPULÄR
            </div>
            <h3 className="text-xl font-semibold text-amber-800 mb-3" data-id="element-340">
              30-dagars testpaket
            </h3>
            <div className="flex justify-between items-center mb-4" data-id="element-341">
              <div data-id="element-342">
                <span className="text-gray-500 line-through" data-id="element-343">374 kr</span>
                <span className="ml-2 bg-red-100 text-red-700 px-2 py-1 rounded-full text-sm font-semibold" data-id="element-344">
                  50% rabatt
                </span>
              </div>
              <div className="text-2xl font-bold text-amber-800" data-id="element-345">187 kr</div>
            </div>
            <div className="flex items-center mb-3 bg-green-50 p-2 rounded-lg" data-id="element-346">
              <div className="text-green-700 font-medium" data-id="element-347">≈ 6,23 kr/dag</div>
              <div className="mx-2 text-gray-400" data-id="element-348">|</div>
              <div className="text-xs text-gray-600" data-id="element-349">
                Mindre än priset för en kopp kaffe
              </div>
            </div>
            <div className="mb-4" data-id="element-350">
              <div className="font-semibold mb-2 flex items-center" data-id="element-351">
                <span className="bg-amber-200 text-amber-800 w-5 h-5 rounded-full flex items-center justify-center mr-2 text-xs" data-id="element-352">
                  1
                </span>
                Din hjärna förlorar upp till 10,000 celler varje dag efter 40
              </div>
              <div className="font-semibold mb-2 flex items-center" data-id="element-353">
                <span className="bg-amber-200 text-amber-800 w-5 h-5 rounded-full flex items-center justify-center mr-2 text-xs" data-id="element-354">
                  2
                </span>
                Brainy ger de exakta näringsämnen din hjärna behöver
              </div>
              <div className="font-semibold mb-2 flex items-center" data-id="element-355">
                <span className="bg-amber-200 text-amber-800 w-5 h-5 rounded-full flex items-center justify-center mr-2 text-xs" data-id="element-356">
                  3
                </span>
                Prova riskfritt med vår 180-dagars garanti
              </div>
            </div>
            <h4 className="font-semibold mb-2 text-gray-700" data-id="element-357">Du får:</h4>
            <ul className="mb-4 space-y-2" data-id="element-358">
              <li className="flex items-start" data-id="element-359">
                <CheckCircleIcon className="h-5 w-5 text-green-600 mt-0.5 mr-2 flex-shrink-0" data-id="element-360" />
                <span data-id="element-361">
                  <span className="font-medium" data-id="element-362">30 dagars förbrukning</span> (60
                  kapslar)
                </span>
              </li>
              <li className="flex items-start" data-id="element-363">
                <TruckIcon className="h-5 w-5 text-green-600 mt-0.5 mr-2 flex-shrink-0" data-id="element-364" />
                <span data-id="element-365">Gratis leverans (värde 49 kr)</span>
              </li>
              <li className="flex items-start" data-id="element-366">
                <ShieldCheckIcon className="h-5 w-5 text-green-600 mt-0.5 mr-2 flex-shrink-0" data-id="element-367" />
                <span data-id="element-368">
                  <span className="font-medium" data-id="element-369">180 dagars</span>{' '}
                  pengarna-tillbaka-garanti
                </span>
              </li>
            </ul>
            <div className="bg-amber-50 p-3 rounded border border-amber-100" data-id="element-370">
              <h4 className="font-semibold mb-2 text-sm" data-id="element-371">
                Vad händer när du klickar?
              </h4>
              <ol className="text-sm space-y-1" data-id="element-372">
                <li className="flex items-start" data-id="element-373">
                  <span className="bg-amber-200 rounded-full h-5 w-5 flex items-center justify-center text-amber-800 mr-2 flex-shrink-0" data-id="element-374">
                    1
                  </span>
                  <span data-id="element-375">Du kommer till vår säkra checkout (SSL-krypterad)</span>
                </li>
                <li className="flex items-start" data-id="element-376">
                  <span className="bg-amber-200 rounded-full h-5 w-5 flex items-center justify-center text-amber-800 mr-2 flex-shrink-0" data-id="element-377">
                    2
                  </span>
                  <span data-id="element-378">Välj betalningssätt (PayPal/kort)</span>
                </li>
                <li className="flex items-start" data-id="element-379">
                  <span className="bg-amber-200 rounded-full h-5 w-5 flex items-center justify-center text-amber-800 mr-2 flex-shrink-0" data-id="element-380">
                    3
                  </span>
                  <span data-id="element-381">Vi skickar din beställning inom 24 timmar</span>
                </li>
              </ol>
            </div>
            <div className="mt-4 text-xs text-red-600 flex items-center" data-id="element-382">
              <AlertTriangleIcon className="h-4 w-4 mr-1" data-id="element-383" />
              <span data-id="element-384">Endast 17 paket kvar till detta pris</span>
            </div>
          </div>
          <div className="flex items-center justify-center bg-white p-3 rounded-lg" data-id="element-385">
            <div className="flex items-center mr-3" data-id="element-386">
              <LockIcon className="h-4 w-4 text-gray-600 mr-1" data-id="element-387" />
              <span className="text-xs text-gray-600" data-id="element-388">Säker betalning</span>
            </div>
            <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/b/b5/PayPal.svg/1200px-PayPal.svg.png" alt="PayPal" className="h-6 mx-2" data-id="element-389" />
            <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/5/5e/Visa_Inc._logo.svg/1200px-Visa_Inc._logo.svg.png" alt="Visa" className="h-6 mx-2" data-id="element-390" />
            <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/2/2a/Mastercard-logo.svg/1200px-Mastercard-logo.svg.png" alt="Mastercard" className="h-6 mx-2" data-id="element-391" />
          </div>
        </div>
        <div className="md:w-1/2" data-id="element-392">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/4ba9sNNKb2N4VYPXSsnUCU/brainy.png" alt="Brainy produktförpackning" className="w-full h-auto rounded-lg shadow-md mb-4" data-id="element-393" />
          <div className="flex items-center justify-center text-amber-800 mb-4" data-id="element-394">
            <TimerIcon className="h-5 w-5 mr-2" data-id="element-395" />
            <span className="font-semibold" data-id="element-396">
              Erbjudandet går ut snart - agera nu
            </span>
          </div>
          <a href="https://addrevenue.io/t?c=3462679&a=986619&l=165" target="_blank" rel="noopener noreferrer" className="block w-full bg-amber-600 hover:bg-amber-700 text-white font-bold py-4 px-6 rounded-lg text-center text-lg transition duration-300 shadow-lg animate-pulse-slow" data-id="element-397">
            JA! Jag vill säkra min hjärnhälsa nu
          </a>
          <p className="text-center text-sm mt-2 text-gray-600" data-id="element-398">
            Klicka på knappen ovan för att säkra ditt specialerbjudande
          </p>
          <div className="mt-4 bg-white p-3 rounded-lg shadow-sm" data-id="element-399">
            <div className="flex items-center mb-2" data-id="element-400">
              <ShieldCheckIcon className="h-5 w-5 text-amber-700 mr-2" data-id="element-401" />
              <span className="font-semibold" data-id="element-402">
                180 dagars pengarna-tillbaka-garanti
              </span>
            </div>
            <p className="text-sm text-gray-700" data-id="element-403">
              Om du inte är 100% nöjd med resultaten av Brainy, skicka bara
              tillbaka den tomma flaskan inom 180 dagar så får du{' '}
              <span className="font-semibold" data-id="element-404">hela köpesumman tillbaka</span> -
              inga frågor ställs.
            </p>
          </div>
          <div className="mt-4 text-xs text-gray-500" data-id="element-405">
            <p data-id="element-406">
              <ArrowRightIcon className="h-3 w-3 inline mr-1" data-id="element-407" />
              <span data-id="element-408">Inga dolda avgifter eller överraskningar</span>
            </p>
          </div>
        </div>
      </div>
      <div className="mt-6 bg-red-50 border border-red-200 p-4 rounded-lg" data-id="element-409">
        <h3 className="text-lg font-semibold text-red-700 mb-2 text-center" data-id="element-410">
          Vad kostar det att inte agera nu?
        </h3>
        <p className="mb-2" data-id="element-411">
          Varje dag utan rätt näring förlorar din hjärna tusentals celler som
          aldrig kommer tillbaka.{' '}
          <span className="font-medium" data-id="element-412">
            Forskning visar att hjärnåldrande börjar redan vid 30-35 års ålder
          </span>{' '}
          - långt innan du märker de första symptomen.
        </p>
        <p className="text-sm italic" data-id="element-413">
          Fråga dig själv: Hur mycket är dina minnen, din självständighet och
          din mentala skärpa värda för dig? Är det värt 6 kronor om dagen att
          skydda dem?
        </p>
      </div>
    </section>;
}